import { render, staticRenderFns } from "./SReadMore.vue?vue&type=template&id=5e4a3ba9&scoped=true"
import script from "./sReadMore.ts?vue&type=script&lang=ts&external"
export * from "./sReadMore.ts?vue&type=script&lang=ts&external"
import style0 from "./SReadMore.vue?vue&type=style&index=0&id=5e4a3ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a3ba9",
  null
  
)

export default component.exports